import { CommonModule, NgStyle } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { ConfigService } from '../../../../my-shared-lib/src/lib/shared-services/config.service';
import { GlobalFilterService } from '../../../../my-shared-lib/src/lib/shared-services/global-filter-service';
import { debounceTime, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { formatStat, snakeCaseToTitleCase } from '../../../../my-shared-lib/src/lib/utils/format.utils';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-number-stats',
  standalone: true,
  imports: [NgStyle, CommonModule, MatIconModule],
  templateUrl: './number-stats.component.html',
  styleUrl: './number-stats.component.scss'
})
export class NumberStatsComponent implements AfterViewInit, OnDestroy {
  @Input() data!: any;
  stat!: string;
  private filterSub!: Subscription;
  private unSubscribe$: Subject<void> = new Subject();
  public hasError = false;
  public errorMessage = '';

  constructor(
    private configService: ConfigService,
    private globalFilterService: GlobalFilterService
  ) { }

  ngAfterViewInit(): void {
    this.globalFilterService.filter$
      .pipe(
        takeUntil(this.unSubscribe$),
        switchMap((filters) => {
          if (this.data.callApiInDefault === false) {
            let mandatoryFiltersSelected = true;
            let missingMandatoryFilterNames: string[] = [];

            if (this.data.mandatoryFilters && this.data.mandatoryFilters.length > 0) {
              for (const mandatoryFilterKey of this.data.mandatoryFilters) {
                const filterValue = filters.queryParams[mandatoryFilterKey] || filters.requestParams[mandatoryFilterKey];
                if (!filterValue || filterValue.length === 0) {
                  mandatoryFiltersSelected = false;
                  missingMandatoryFilterNames.push(snakeCaseToTitleCase(mandatoryFilterKey));
                }
              }
            }

            if (!mandatoryFiltersSelected) {
              this.hasError = true;
              this.errorMessage = `Please select ${missingMandatoryFilterNames.join(' and ')} to see the data.`;
              return of(null);
            }
          }
          this.hasError = false;
          return this.loadStat(filters);
        })
      )
      .subscribe({
        next: (res: any) => {
          if (res === null) {
            return;
          }

          const parent = this.data?.parentKey ? res[this.data?.parentKey] : res;
          const rawValue = parent?.[this.data.key];

          if (rawValue === undefined || rawValue === null) {
            this.hasError = true;
            this.errorMessage = 'No data found for the selected filters.';
            this.stat = '';
          } else {
            this.hasError = false;
            this.stat = this.data?.useFormatStat
              ? formatStat(
                rawValue,
                this.data?.key || '',
                this.data?.prefix || ''
              )
              : rawValue;
          }
        },
        error: (err) => {
          this.hasError = true;
          this.errorMessage = 'Error loading stat.';
          console.error('Error loading stat:', err);
        },
      });
  }
  get formattedTitle(): string {
    return this.data?.title?.replace(/\n/g, '<br>') || '';
  }


  loadStat(filters?: any): any {
    return this.configService.getConfig(this.data?.apiUrl, {
      ...filters,
      useQueryParams: this.data?.useQueryParams || false
    })
  }

  ngOnDestroy(): void {
    this.filterSub?.unsubscribe();
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
